import { ConfigServiceApiService } from '../api'
import { useGlobalCtx, useGlobalCtxDispatch } from "../Context/GlobalContext"
import { useCallback } from 'react';
import { languageResources } from '../Utils/messages';

export  function useThemeKeyValues() {
  const globalCTX = useGlobalCtx()
  const globalCtxDispatch = useGlobalCtxDispatch();

  const getThemeKeyValueCommand = useCallback((theme:string,lang:string) => {
    ConfigServiceApiService.getV1ConfigThemes(
      theme.toUpperCase() === "ARCS"?"default":theme,
      lang
    )
      .then((data: any) => {
        const messages = JSON.parse(data.messages);
        globalCTX.Theme === "" &&  globalCtxDispatch({type:"setTheme", value: data.defaultTheme.toUpperCase() === "DEFAULT"?"ARCS":data.defaultTheme});
        globalCTX.Language === "" &&  globalCtxDispatch({type:"setLanguage", value: data.defaultLanguage});
        globalCtxDispatch({type:"setLanguageResources", value: {...languageResources.en_US,...messages.SurveyLanguage}});
        globalCtxDispatch({type:"setHeader", value: messages?.header??[]});
        globalCtxDispatch({type:"setFooter", value: messages?.footer??[]});
      })
      .catch((e) => {
        console.log(e);
        //({type:"setTheme", value: "ARCS"})
        globalCtxDispatch({type:"setLanguageResources", value: languageResources.en_US});
      })
  }, [])

  return { getThemeKeyValueCommand }
  
}

